// extracted by mini-css-extract-plugin
export var searchHeader = "_1o-0";
export var searchHeaderDark = "_1o-1";